/**
 * Web-specific constants for the Meander EV app
 * These values control the layout and positioning of web-specific components
 */

// Maximum width of the app container on web (matches mobile viewport)
export const WEB_APP_MAX_WIDTH = 430;

// Menu width as a percentage of app width
export const WEB_MENU_WIDTH_PERCENT = 0.85;

// Calculated menu width (capped at 380px)
export const WEB_MENU_WIDTH = Math.min(WEB_APP_MAX_WIDTH * WEB_MENU_WIDTH_PERCENT, 380);

// Z-index values for layering
export const Z_INDEX = {
  APP_CONTENT: 1,
  OVERLAY_BACKDROP: 9998,
  OVERLAY_CONTENT: 9999,
  MODAL: 10000,
  TOAST: 10001,
};

// Animation durations (in ms)
export const ANIMATION_DURATION = {
  MENU_SLIDE: 250,
  OVERLAY_FADE: 250,
  CARD_SLIDE: 300,
};

// Colors
export const WEB_COLORS = {
  BACKDROP: 'rgba(0, 0, 0, 0.5)',
  APP_BACKGROUND: '#1A1D21',
};

